
function TimestampRow({report, row, index, onHide}){
    return <tr onClick={() => onHide(index)}>
        <td style={{padding: "0 10px 0 10px"}}>
            <p
                style={{
                    fontFamily: report.config.template.templateFonts.text,
                    fontWeight: 'normal',
                    fontSize: 18,
                    color: report.config.template.templateColors.elements
                }}
            >
                {row.content}
            </p>
        </td>
    </tr>;
}
export default TimestampRow;